import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Papelaria = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Escritório";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.headerPapelaria})` }}>
        <div className="servico-hero-overlay">
          <h1>Escritório</h1>
          {/* <p>Para quem procura por itens de escritório</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Presentes e Papelaria */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.canetas} alt="" /></div>
            <h3>Recargas</h3>
            <p>Cargas de caneta e reposições.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.leituraLupa} alt="" /></div>
            <h3>Leitura</h3>
            <p>Lupas.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.colaAdesivos} alt="" /></div>
            <h3>Fixação</h3>
            <p>Colas, fitas e adesivos.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.identificacaoCrachas} alt="" /></div>
            <h3>Identificação</h3>
            <p>Porta-crachás, porta-identidade.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('escritório')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('escritório')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Papelaria;